import acc from "accounting"
import { Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Icon from "../../../../Icon"
import { SUMMARY_BLOCKS } from "../../reducer"
import FallbackMarker from "../IconCell/FallbackMarker"

import styles from "./SummaryBlocks.module.less"

const { Text } = Typography

const formatCount = (value) => acc.formatNumber(value || 0, 0, ",", ".")

/**
 * The three blocks are not read-only indicators — each one filters the table.
 *
 * Their counts are computed over the entire dataset and never react to the filter bar, which is
 * what lets support see how much work is left while looking at a narrowed list. A value counts as
 * mapped only when it has a UI name: an icon alone does not make it mapped.
 */
const SummaryBlocks = ({ summary, selected, onSelect }) => {
  const { t } = useTranslation()

  const blocks = [
    {
      key: SUMMARY_BLOCKS.ALL,
      label: t("All values"),
      value: summary?.all_values,
      percent: null,
      marker: null
    },
    {
      key: SUMMARY_BLOCKS.MAPPED,
      label: t("Mapped"),
      value: summary?.mapped,
      percent: summary?.mapped_percent,
      marker: <Icon type="circle_check" className={styles.mappedMarker} />
    },
    {
      key: SUMMARY_BLOCKS.UNMAPPED,
      label: t("Unmapped"),
      value: summary?.unmapped,
      percent: summary?.unmapped_percent,
      // The same graphic the table uses for a missing icon: one symbol means "not filled in".
      marker: <FallbackMarker />
    }
  ]

  return (
    <div className={styles.wrapper}>
      {blocks.map(({ key, label, value, percent, marker }) => (
        <button
          key={key}
          type="button"
          className={cls(styles.block, { [styles.selected]: selected === key })}
          aria-pressed={selected === key}
          data-testid={`payment-matching-block-${key}`}
          onClick={() => onSelect(key)}
        >
          <Flex align="center" gap={6}>
            <Text type="secondary" className={styles.label}>
              {label}
            </Text>
            {marker}
          </Flex>

          <Flex align="baseline" gap={8}>
            <span className={styles.value}>{formatCount(value)}</span>
            {percent === null ? null : (
              <Text type="secondary" className={styles.percent}>
                {percent}%
              </Text>
            )}
          </Flex>
        </button>
      ))}
    </div>
  )
}

export default SummaryBlocks
